<template>
    <div>
        <form @submit.prevent="onSubmit"
              class="row gutter-sm"
              @keydown="form.onKeydown($event)">

            <v-select path="partner_id"
                      auto-select
                      v-model="form.partner_id"
                      :label="$t('Partner')"
                      optional
                      :options="partners"
                      :form="form"
                      v-if="enable_partner === '1' && user.role_id === 7 && $route.name === 'lending-point.order'"
                      class="col-sm-12 col-xs-12">
            </v-select>
            <v-input path="firstname"
                     v-model="form.firstname"
                     :label="$t('first name')"
                     :form="form"
                     class="col-sm-6 col-xs-12">
            </v-input>

            <v-input path="lastname"
                     v-model="form.lastname"
                     :label="$t('last name')"
                     :form="form"
                     class="col-sm-6 col-xs-12">
            </v-input>

            <v-select path="phone_prefix"
                      auto-select
                      v-model="form.phone_prefix"
                      :label="$t('phone prefix')"
                      :item-plural="$t('phone prefixes')"
                      :options="phonePrefixes"
                      :form="form"
                      class="col-md-4 col-sm-6 col-xs-12">
            </v-select>

            <v-input path="phone"
                     v-model="form.phone"
                     :label="$t('cell phone')"
                     :form="form"
                     class="col-md-4 col-sm-6 col-xs-12">
            </v-input>

            <v-input path="email"
                     v-model="form.email"
                     :label="$t('email')"
                     :form="form"
                     class="col-md-4 col-sm-6 col-xs-12">
            </v-input>

            <v-display v-model="startLendingAt"
                       :label="$t('lending start date')"
                       :form="form"
                       class="col-sm-6 col-xs-12">
            </v-display>

            <v-datetime path="end_lending_at"
                        v-model="form.end_lending_at"
                        :label="$t('lending end date')"
                        format-data="YYYY-MM-DD"
                        format="DD-MM-YYYY"
                        :form="form"
                        :min="minEndLendingAt"
                        class="col-sm-6 col-xs-12">
            </v-datetime>
            <v-select path="document_type"
                      auto-select
                      v-model="form.document_type"
                      :label="$t('document type')"
                      :item-plural="$t('document types')"
                      :options="documentTypes"
                      :form="form"
                      :clearable="false"
                      class="col-sm-3 col-xs-12">
            </v-select>

            <v-input path="dni"
                     v-model="form.dni"
                     :label="$t('dni/nie')"
                     :form="form"
                     class="col-sm-3 col-xs-12">
            </v-input>

            <v-input  path="birthdate"
                      v-model="form.birthdate"
                      :label="$t('birth date')"
                      :form="form"
                      class="col-sm-3 col-xs-12"
            >
            </v-input>

            <v-input path="zipcode"
                     v-model="form.zipcode"
                     :label="$t('zip code')"
                     :form="form"
                     class="col-sm-3 col-xs-12">
            </v-input>

            <v-select path="consumer_type_id"
                      auto-select
                      v-model="form.consumer_type_id"
                      :label="$t('consumer type')"
                      :item-plural="$t('consumer types')"
                      :options="mockData.consumerTypes"
                      :form="form"
                      class="col-sm-6 col-xs-12">
            </v-select>

            <v-select path="lending_kit_id"
                      v-model="form.lending_kit_id"
                      :label="$t('lending kit')"
                      :item-plural="$t('lending kits')"
                      :options="lendingKits"
                      :form="form"
                      class="col-md-6 col-sm-12 col-xs-12">
            </v-select >

            <!-- REMOTE COACH -->
            <div class="col-12" v-if="$route.name === 'remote-coach.reservation'">
                <div class="row gutter-sm">

                    <div class="col-8">
                        <div tabindex="-1"
                             class="q-if row no-wrap relative-position q-input q-if-standard q-if-has-content text-highlight">
                            <div class="q-if-baseline">|</div>
                            <div class="q-if-inner col column">
                                <div class="row no-wrap relative-position"><span
                                    class="q-if-addon q-if-addon-left q-if-addon-visible">{{ $T('search') }}:&nbsp;</span>
                                    <!-- <gmap-autocomplete :value="consumerLocation" class="col q-input-target q-no-input-spinner ellipsis"  @place_changed="setPlace"/> -->
                                    <gmap-autocomplete class="col q-input-target q-no-input-spinner ellipsis"
                                                       select-first-on-enter
                                                       @keypress.13.prevent=""
                                                       @place_changed="setPlace"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-4">
                        <v-input path="filterKey"
                                 v-model="filterKey"
                                 :prefix="`${$T('filter')}:&nbsp;`"
                                 :form="form">
                        </v-input>
                    </div>

                    <div class="col-8">

                        <GmapMap :center="mapCenter"
                                 :zoom="mapZoom"
                                 map-type-id="roadmap"
                                 style="width: 100%; height: 400px">
                            <gmap-marker v-for="(lendingPoint, i) in lendingPointsWithStock"
                                         :key="i"
                                         :position="parseCoords(lendingPoint.coords)"
                                         :clickable="true"
                                         :title="lendingPoint.description"
                                         @click="select(lendingPoint)"
                            ></gmap-marker>
                            <gmap-marker v-if="consumerLocation" :position="consumerLocation" :icon="'https://img.icons8.com/cotton/64/000000/men-age-group-4.png'"/>
                        </GmapMap>

                    </div>
                    <div class="col-4">

                        <q-scroll-area style="width: 100%; height: 400px; border: 1px solid #ddd">
                            <q-list inset-separator no-border link>
                                <q-item v-for="(lendingPoint, i) in filteredLendingPoints"
                                        :key="i" multiline
                                        @click.native="select(lendingPoint)">
                                    <q-item-side
                                        :icon="isSelected(lendingPoint) ? 'check circle' : 'place'"
                                        inverted
                                        :color="isSelected(lendingPoint) ? 'highlight' : 'primary'"/>
                                    <q-item-main>
                                        <q-item-tile label>{{ lendingPoint.description }}</q-item-tile>
                                        <q-item-tile sublabel>
                                            {{ lendingPoint.address }},
                                            {{ lendingPoint.address_2 }} -
                                            {{ lendingPoint.city }},
                                            {{ lendingPoint.zipcode }}
                                        </q-item-tile>
                                        <q-item-tile sublabel>
                                            {{ $T('distance') }} {{ distanceInMeter(consumerLocation, parseCoords(lendingPoint.coords)) }}
                                        </q-item-tile>
                                    </q-item-main>
                                    <q-item-side right :stamp="`${unitsFrom(lendingPoint)} ${$T('un.')}`"/>
                                </q-item>
                            </q-list>
                        </q-scroll-area>

                    </div>
                </div>
            </div>
            <!-- END REMOTE COACH -->


            <v-display :value="$T('privacy policy, terms and conditions, commercial communications')"
                       :form="form"
                       class="col-12"
                       color="grey"
                       v-if="$route.name !== 'remote-coach.reservation'"
                       style="cursor: pointer;"
                       @click.native.prevent="termsAndConditions = true">
            </v-display>

            <v-input path="observations"
                     v-model="form.observations"
                     :label="$t('observations')"
                     optional
                     :form="form"
                     type="textarea"
                     v-if="$route.name !== 'remote-coach.reservation'"
                     class="col-12">
            </v-input>


            <!-- Submit Button -->
            <div class="col-12 row justify-center q-mt-md">
                <v-button outline
                          :label="$T('save')"
                          icon="save"
                          color="highlight"
                          class="no-shadow uppercase q-btn-iqos"
                          :loading="form.busy"
                          :disable="form.busy"
                          @click.native.prevent="orderSubmit">
                    <template slot="loading">
                        <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                        {{ $T('saving...') | capitalize }}
                    </template>
                </v-button>
            </div>

        </form>
        <terms-and-conditions
            v-if="termsAndConditions"
            :form="form"
            :mock-data="mockData"
            @close-terms-and-conditions="termsAndConditions = false"
            @accept-terms-and-conditions="acceptTermsAndConditions">
        </terms-and-conditions>
    </div>
</template>

<script>
import Form from 'vform'
import moment from 'moment'
import axios from 'axios'
import {
    QSpinnerPuff,
    QSlideTransition
} from 'quasar-framework'
import orderModel from '../orderModel'
import phoneprefixes from '../../../../helpers/phonePrefix'
import TermsAndConditions from "../termsAndConditions"
import VDisplay from "../../../../components/form/VDisplay"
import {mapGetters} from 'vuex'

export default {
    middleware: 'auth',

    mixins: [orderModel, phoneprefixes],

    components: {
        VDisplay,
        TermsAndConditions,
        QSpinnerPuff,
        QSlideTransition
    },
    props: {
        mockData: Object
    },

    data() {
        return {
            newLendingFromBrokenKit: false,
            consumerLocation: '',
            distance: '',
            form: {},
            documentTypes: [
                {value: 'dni', label: this.$T('dni/nie')},
                {value: 'other', label: this.$T('other')}
            ],
            termsAndConditions: false,
            lendingKits: [],
            minBirthdayDate: moment('19200101','YYYYMMDD').format('YYYY-MM-DD'),
            maxBirthdayDate: moment().subtract(18 , 'years').format('YYYY-MM-DD'),
            mapZoom: 6,
            mapCenter: {
                lat: 40.4378698,
                lng: -3.8196193
            },
            filterKey: '',
            enable_partner: false,
            partners: []
        }
    },

    computed: {
        startLendingAt() {
            if (this.newLendingFromBrokenKit) return moment(this.form.start_lending_at).format('DD-MM-YYYY')
            return moment().format('DD-MM-YYYY')
        },

        endLendingAt() {
            return moment().add(this.mockData.lendingDays, 'days').format('YYYY-MM-DD')
        },

        minEndLendingAt() {
            return moment().add(this.mockData.minimumLendingDays, 'days').format('YYYY-MM-DD')
        },
        ...mapGetters({
            user: 'auth/user'
        }),

        lendingPointsWithStock() {
            return this.mockData['lendingPoints'].filter(item => this.unitsFrom(item) > 0)
        },
        filteredLendingPoints() {
            let filterKey = this.filterKey && this.filterKey.toLowerCase()
            let data = this.lendingPointsWithStock
            if (filterKey) {
                data = data.filter(row => Object.keys(row)
                    .some(key => String(row[key]).toLowerCase().indexOf(filterKey) > -1))
            }
            return data
        },
    },

    methods: {
        setup() {
            //Gets form data on the previous order marked as "Préstimo defeituoso")
            let formData = (this.$route.params && this.$route.params.hasOwnProperty('formData') && this.$route.params.formData) ? this.$route.params.formData : this.orderModel;
            if (formData['consumer_type.description']) {
                let index = this.mockData.consumerTypes.findIndex( type => {
                    return type.label == formData['consumer_type.description']
                })
                if (index >= 0) {
                    formData.consumer_type_id = this.mockData.consumerTypes[index].value
                }
            }
            this.enable_partner = this.mockData.enable_partner
            this.partners = this.mockData.partners.map(p => ({
                value: p.id,
                label: p.name
            }))

            this.$route.params.formData = {}
            this.form = new Form(formData)
            this.form.end_lending_at = this.endLendingAt
            this.form.minimum_lending_at = this.minEndLendingAt
            if (this.$route.name !== 'remote-coach.reservation') {
                this.lendingKits = this.loadLendingKits()
            }

            if (formData['start_lending_at']) {
                this.newLendingFromBrokenKit = true
                this.form.end_lending_at = formData['end_lending_at']
            }
            // For Remote Coach Map
            if (window.config.market === "CI") {
                this.mapZoom = 8.23
                this.mapCenter.lat = 28.3509903
                this.mapCenter.lng = -14.7892996
            }
        },

        async onSubmit() {
            if (this.form.busy) return

            let response = await this.form.post(`/api/v1/lending-point/order`)
            if (!response.data) return
            let {data} = response
            this.form = new Form(this.orderModel)
            this.$q.dialog({
                title: this.$T('success'),
                message: data.success.message,
                preventClose: true,
                color: 'primary',
                stackButtons: true,
                ok: {
                    label: this.$T('go to list'),
                },
                cancel: {
                    color: 'negative',
                    label: `${this.$T('new')} ${this.$t('order')}`,
                }
            }).then(() => {
                this.$router.push({name: 'lending-point.orders'})
            }).catch(() => {
                this.getUpdatedLendingKits()
                this.form.end_lending_at = this.endLendingAt
                this.form.minimum_lending_at = this.minEndLendingAt
            })
        },
        async getUpdatedLendingKits() {
            const {data} = await axios.get(`${config.appUrl}/api/v1/lending-point/order/form-mock-data`)
            this.lendingKits = data.data.lendingKits.map(item => ({
                label: `${this.$T('codentify')}: ${item.codentify}`,
                value: item.id,
                sublabel: `${this.$T('product')}: ${item.product_model ? item.product_model.description : ''} ${item.product_color ? item.product_color.description : ''}, ${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
            }))
        },
        acceptTermsAndConditions() {
            this.termsAndConditions = false;
        },
        orderSubmit() {
            if (this.$route.name === 'remote-coach.reservation') {
                this.onSubmit()
            } else {
                if (!this.form.terms_and_conditions) {
                    this.$q.dialog({
                        title: this.$T('terms and conditions'),
                        message: this.$T('to create a order you need to accept the terms and conditions first'),
                        preventClose: true,
                        color: 'primary',
                        stackButtons: true,
                        ok: {
                            label: this.$T('ok'),
                        },
                    }).then(() => {
                    }).catch(() => {
                    })
                }
                else this.onSubmit()
            }
        },
        loadLendingKits() {
            return this.mockData.lendingKits.map(item => ({
                label: `${this.$T('codentify')}: ${item.codentify}`,
                value: item.id,
                sublabel: `${this.$T('product')}: ${item.product_model ? item.product_model.description : ''} ${item.product_color ? item.product_color.description : ''}, ${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
            }))
        },
        setPlace(place) {
            if (place && place.geometry) {
                this.mapCenter = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng()
                }
                this.consumerLocation = this.mapCenter
                this.mapZoom = 13
            }
        },
        unitsFrom(lendingPoint) {
            let kitsAvailable = lendingPoint.kits_available ? lendingPoint.kits_available.count : 0
            let reservations = lendingPoint.reservations ? lendingPoint.reservations.count : 0
            return kitsAvailable - reservations
        },
        isSelected(lendingPoint) {
            return this.form.lending_point_id == lendingPoint.id
        },

        select(lendingPoint) {
            if (this.form.lending_point_id == lendingPoint.id) {
                this.form.lending_point_id = null
                return
            }
            this.form.lending_point_id = lendingPoint.id
            this.form['order_status_id'] = 8
            this.mapCenter = lendingPoint.coords
            this.mapZoom = 16
            this.updateLendingKitList(lendingPoint.id)
            this.distance = this.distanceInMeter(this.consumerLocation, this.parseCoords(lendingPoint.coords))
        },
        async updateLendingKitList (lendingPointId) {
            if (lendingPointId === null) {
                lendingPointId = this.user.lending_point_id
            }
            const {data} = await axios.get(`${config.appUrl}/api/v1/lending-point/reservation/kits/${lendingPointId}`)
            this.lendingKits = data.map(item => ({
                label: `${this.$T('codentify')}: ${item.codentify}`,
                value: item.id,
                sublabel: `${this.$T('product')}: ${item.product_model ? item.product_model.description : ''} ${item.product_color ? item.product_color.description : ''}, ${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
            }))
        },
        distanceInMeter (p1, p2) {
            if (p1 && p2) {
                var vm = parseInt(google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(p1),new google.maps.LatLng(p2)))
                if (vm > 1000) {
                    return (vm / 1000).toFixed(2) + ' Km'
                }
                return vm + ' m'
                return
            } else {
                return null
            }
        },
        parseCoords (value) {
            if (typeof (value) == 'string')
                try {
                    value = JSON.parse(value);
                } catch (e) {
                }
            if (!this.isValidCoords(value))
                value = null

            return value
        },
        isValidCoords(value) {
            return value &&
                typeof value == 'object' &&
                'lat' in value &&
                value.lat &&
                typeof value.lat == 'number' &&
                'lng' in value &&
                value.lng &&
                typeof value.lng == 'number'
        }
    },

    mounted() {
        this.setup()
        if (this.mockData.phone_number && this.mockData.phone_prefix) {
            this.form.phone = this.mockData.phone_number
            this.form.phone_prefix = this.mockData.phone_prefix
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/markets/CI/pages/lending-point/orderForm.vue